import { defineMessages } from 'react-intl';

export default defineMessages({
  paginationTotal: '{start}-{end} of {total} items',
  paginationPerPage: '/ page',
});
